import type { Role } from "../types";

export interface WorkspaceRoleDataSeen {
  restaurant: boolean;
  supplier: boolean;
}

export type WorkspaceOverviewMode =
  | "admin"
  | "restaurant-first-run"
  | "restaurant-operating"
  | "supplier-first-run"
  | "supplier-operating";

export interface WorkspaceRoleEntry {
  firstRunWorkspace: boolean;
  overviewMode: WorkspaceOverviewMode;
  realRestaurantDataActive: boolean;
  realSupplierDataActive: boolean;
  restaurantHasOperatingHistory: boolean;
  restaurantSimpleDashboard: boolean;
  roleHasRealData: boolean;
  shouldShowCommandStrip: boolean;
  shouldShowDashboardActionCenter: boolean;
  supplierSetupNeeded: boolean;
}

function overviewModeFor(role: Role, dataSeen: WorkspaceRoleDataSeen): WorkspaceOverviewMode {
  if (role === "admin") {
    return "admin";
  }

  if (role === "supplier") {
    return dataSeen.supplier ? "supplier-operating" : "supplier-first-run";
  }

  return dataSeen.restaurant ? "restaurant-operating" : "restaurant-first-run";
}

export function workspaceRoleEntryFor(role: Role, dataSeen: WorkspaceRoleDataSeen): WorkspaceRoleEntry {
  const overviewMode = overviewModeFor(role, dataSeen);
  const realRestaurantDataActive = dataSeen.restaurant;
  const realSupplierDataActive = dataSeen.supplier;
  const roleHasRealData =
    role === "admin" || (role === "supplier" ? realSupplierDataActive : realRestaurantDataActive);
  const supplierSetupNeeded = overviewMode === "supplier-first-run";
  const restaurantHasOperatingHistory = overviewMode === "restaurant-operating";
  const restaurantSimpleDashboard = overviewMode === "restaurant-first-run";
  const firstRunWorkspace = restaurantSimpleDashboard || supplierSetupNeeded;

  return {
    firstRunWorkspace,
    overviewMode,
    realRestaurantDataActive,
    realSupplierDataActive,
    restaurantHasOperatingHistory,
    restaurantSimpleDashboard,
    roleHasRealData,
    shouldShowCommandStrip: role === "admin",
    shouldShowDashboardActionCenter: role === "admin",
    supplierSetupNeeded,
  };
}
